<template>
    <select class="input-small input__field" v-model="item">
        <option v-bind:value="null">{{ defaultLabel }}</option>
        <optgroup v-for="product in items" v-bind:key="'product-' + product.encoded_id" v-bind:label="product.title">
            <option v-for="feature in product.features" v-bind:value="feature" v-bind:key="'feature-' + feature.encoded_id">{{ feature.title }}</option>
        </optgroup>
    </select>
</template>
<script>
export default {
    props: {
        products: {
            type: Array,
            required: true,
        },
        selected: {
            type: Object,
            default: null,
        },
        defaultLabel: {
            type: String,
            default: 'All Products',
        },
    },
    data() {
        return {
            item: this.selected,
            items: this.products.map(product => {
                return {
                    title: product.title,
                    encoded_id: product.encoded_id,
                    features: product.product_features.map(feature => {
                        return {
                            type: feature.type,
                            title: feature.label,
                            encoded_id: feature.encoded_id,
                            encoded_product_id: feature.encoded_product_id,
                        }
                    })
                }
            })
        }
    },
    watch: {
        selected(selected) {
            this.item = selected;
        },
        item(selected) {
            this.$emit('update:selected', selected);
        },
    },
}
</script>
